import { Component, computed, input } from '@angular/core';
import { apiUrl } from '@app/app.constants';
import { PortalNotificationLike } from '@business/notification/models/portal-notification-helpers';

@Component({
  selector: 'portal-notification-live-view-title-image',
  standalone: true,
  template: `
    @if (media() != null) {
      <figure class="media">
        <img [alt]="media().fileName" [src]="imageUrl()" />
      </figure>
    }
  `,
  styles: `
    img {
      max-width: 100%;
    }
  `,
})
export class NotificationLiveViewTitleImageComponent {
  notification = input.required<PortalNotificationLike>();
  media = computed(() => {
    return this.notification().translations.find((translation) => translation.orderIndex === 0)?.media;
  });
  imageUrl = computed(() =>
    this.media() != null ? apiUrl(`/reseller/media/${this.media().id}/download`) : null
  );
}
